<template>
  <div>
    <!-- 问题登记 -->
    <el-dialog :title="$t('message.issueCreate')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">
          <!-- 是否问题： -->
          <el-form-item label="是否问题：:" prop="is_problem" v-if="form.chat_type">
            <el-radio-group v-model="form.is_problem">
              <el-radio :label="1">确认为问题</el-radio>
              <el-radio :label="0">非问题</el-radio>
            </el-radio-group>
            <el-popover placement="top" title="非问题" width="200" trigger="hover">
              <p>人为判断系统抓取的聊天内容不是问题， <br>
                例：系统匹配错误</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <!-- 是否投诉： -->
          <el-form-item label="是否投诉：:" prop="is_complaint" v-if="form.chat_type">
            <el-radio-group v-model="form.is_complaint">
              <el-radio :label="1">非投诉</el-radio>
              <el-radio :label="2">确认投诉</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- *确认结果 -->
          <el-form-item label="确认结果:" prop="confirm_result">
            <el-input v-model="form.confirm_result" placeholder="请输入确认结果" type="textarea" />
          </el-form-item>
          <!-- 问题分类-->
          <el-form-item label="问题分类:">
            <el-select v-model="form.problem_category" placeholder="请选择问题分类">
              <el-option v-for="(item, index) in problemCategoy" :label="item.value" :value="item.value" :key="index" />
            </el-select>
          </el-form-item>
          <!-- 选择商品： -->
          <el-form-item label="选择商品:">
            <el-radio-group v-model="radio" @change="setRadio">
              <el-radio :label="1">配送单</el-radio>
              <el-radio :label="2">订单</el-radio>
            </el-radio-group>
            <div class="row">
              <div class="input" v-if="radio == 1">
                <el-input v-model="form.porder_sn" placeholder="请输入配送单" />
              </div>
              <div class="input" v-else>
                <el-input v-model="form.order_sn" placeholder="请输入订单" />
              </div>
              <el-button type="primary" @click="getPorderDetail">选择商品</el-button>
            </div>
            <!-- 配送单详情 -->
            <div class="list" v-if="radio == 1">
              <p v-for="(item, index) in form.porder_detail" :key="index">
                {{ item.order_sn }} No{{ item.sorting }}
              </p>
            </div>
            <!-- 订单详情 -->
            <div class="list" v-if="radio == 2">
              <p v-for="(item, index) in form.order_detail" :key="index">
                {{ item.order_sn }} No{{ item.sorting }}
              </p>
            </div>
          </el-form-item>
          <!-- *不良数： -->
          <el-form-item label="不良数:" prop="problem_num">
            <el-input v-model="form.problem_num" placeholder="请输入不良数" type="number" />
          </el-form-item>
          <!-- *不良金额（元）： -->
          <el-form-item label="不良金额（元）:" prop="problem_amount">
            <el-input v-model="form.problem_amount" placeholder="请输入不良金额（元）" type="number" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 配送单详情 -->
    <porderDetail ref="porderDetail" />
    <!-- 订单详情 -->
    <orderDetail ref="orderDetail" />
  </div>
</template>
<script>
import porderDetail from './porderDetail.vue'
import orderDetail from './orderDetail.vue'

export default {
  components: {
    porderDetail,
    orderDetail
  },
  props: {
    problemCategoy: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        client_id: '',
        problem_images: [],
        confirm_result: '',
        problem_category: '',
        product_id: '',
        order_id: '',
        problem_num: '',
        problem_amount: '',
        porder_sn: '',
        order_sn: '',
        porder_detail: [],
        order_detail: []
      },
      rules: {
        client_id: [{ required: true, message: '请输入客户ID', trigger: 'blur' }],
        problem_images: [{ required: true, message: '请上传问题图片', trigger: 'blur' }],
        confirm_result: [{ required: true, message: '请输入售后问题说明', trigger: 'blur' }],
        problem_category: [{ required: true, message: '请选择问题分类', trigger: 'blur' }],
        product_id: [{ required: true, message: '请输入配送单', trigger: 'blur' }],
        order_id: [{ required: true, message: '请输入订单', trigger: 'blur' }],
        problem_num: [{ required: true, message: '请输入不良数', trigger: 'blur' }],
        problem_amount: [{ required: true, message: '请输入不良金额（元）', trigger: 'blur' }],
        is_problem: [{ required: true, message: '请选择是否问题', trigger: 'blur' }],
        is_complaint: [{ required: true, message: '请选择是否投诉', trigger: 'blur' }],
      },
      dialogVisible: false,

      radio: 1,
      chat_type: '',
    };
  },
  created() {

  },
  methods: {

    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.aftersaleIssueConfirm(this.form).then(res => {
            this.$message.success(res.msg);
            this.$parent.aftersaleIssueList();
            this.$parent.aftersaleIssueStatusStatistics();
            this.dialogVisible = false;
          })
        } else {
          this.$message.error('请填写完整信息');
        }
      })
    },
    // 选择商品类型改变时
    setRadio() {
      this.form.porder_detail = []
      this.form.order_detail = []
      this.form.porder_sn = ''
      this.form.order_sn = ''
    },
    // 获取配送单详情
    getPorderDetail() {
      if (this.radio == 1) {
        if (!this.form.porder_sn) {
          this.$message.error('请输入配送单');
          return;
        }
        this.$refs.porderDetail.porder_sn = this.form.porder_sn
        this.$refs.porderDetail.getPorderDetail()
      } else if (this.radio == 2) {
        if (!this.form.order_sn) {
          this.$message.error('请输入订单');
          return;
        }
        this.$refs.orderDetail.order_sn = this.form.order_sn
        this.$refs.orderDetail.getOrderDetail()
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    .input {
      width: 300px;
      margin-right: 20px;
    }
  }

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }

  .avatar-uploader {
    height: 80px;
    width: 80px;
  }

  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }

  .list {
    margin-top: 10px;

    p {
      line-height: 30px;
    }
  }

  .el-icon-question {
    font-size: 20px;
    color: #B4272D;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>